import type { FC } from "react"

import { PaymentTermsDisplay } from "./PaymentTermsDisplay"

import type { CompanyAccountingTerm } from "@/graphql/codegen/graphql"

interface Props {
  customerPaymentTerm?: CompanyAccountingTerm
}

export const CustomerPaymentTermItem: FC<Props> = ({ customerPaymentTerm }) => {
  return <PaymentTermsDisplay name='Customer Payment Terms' value={customerPaymentTerm?.paymentTerm?.name ?? ""} />
}
